import styles from './Button.module.css';

interface ButtonProps {
  variant?: 'primary' | 'ghost';
  href?: string;
  target?: string;
  rel?: string;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
  children: React.ReactNode;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
}

export function Button({
  variant = 'primary',
  href,
  target,
  rel,
  children,
  className = '',
  onClick,
  type = 'button',
  disabled,
}: ButtonProps) {
  const cls = `${variant === 'primary' ? styles.primary : styles.ghost} ${className}`;

  if (href) {
    return (
      <a href={href} className={cls} target={target} rel={rel} onClick={onClick}>
        {children}
      </a>
    );
  }

  return (
    <button className={cls} type={type} disabled={disabled} onClick={onClick}>
      {children}
    </button>
  );
}
